export default __webpack_public_path__ + "static/media/return-voucher-icon.758c8779.svg";